
import React from 'react'
import { HashRouter, Route, Routes, useLocation } from 'react-router-dom'
import DeleteAction from './TicketDetails/Sections/DeleteAction';
import AttachmentsPopup from './TicketDetails/Sections/AttachmentsPopup';
import ValidationPopup from './TicketDetails/Sections/Tools/Close/ValidationPopup';
import Share from './TicketDetails/Sections/Share';
import MapView from './TicketDetails/Sections/MapView';
import PrintWindow from './TicketDetails/Sections/Tools/Print/PrintWindow';
import ActionFilter from './TicketDetails/Sections/Tools/Filter/ActionFilter';
import KBModal from './TicketDetails/Sections/Tools/KB/KBModal';
import RelatedTicketsModal from './TicketDetails/Sections/Tools/Related/RelatedTicketsModal';
import AssignedModal from './TicketDetails/Sections/Tools/Reassign/AssignedModal';
import AINotes from './TicketDetails/Sections/AINotes';
import DeleteDockItem from './TicketDetails/Sections/Dock/DeleteDockItem';
import HierarchyWindow from './TicketDetails/Sections/Tools/Hierarchy/HierarchyModal';
import EmailModal from './TicketDetails/Sections/Tools/Email/EmailModal';
import AssetModal from './TicketDetails/Sections/Tools/Assets/AssetModal';
import ActionModal from '../Action/ActionModal';
import AddAssetModal from '../Asset/AddAssetModal';
import AllocationModal from '../Gameplan/AllocationModal';
import MoveTicketsModal from './TicketDetails/Sections/Tools/Move/MoveTicketsModal';
import Progress from '../Gameplan/Progress';
import GameplanDetails from '../Gameplan/GameplanDetails';

const TicketRoutes: React.FC = (props) => {
    let location = useLocation();
    let background = location.state && (location.state as TicketLocationState).background;
    let k = 1;
    return (
        <Routes>
            <Route path="contact/:contactId/*" />
            <Route path="action" element={<ActionModal index={8} key={k++} />}>
                <Route path="Kbase" element={<KBModal key={k++} />} />
            </Route>
            <Route path="action/:actionId" element={<ActionModal index={8} key={k++} />} />
            <Route path="action/:actionId/delete" element={<DeleteAction key={k++} />} />
            <Route path="action/:actionId/files" element={<AttachmentsPopup key={k++} />} />
            <Route path="files/:id" element={<AttachmentsPopup key={k++} />} />
            <Route path="files" element={<AttachmentsPopup key={k++} />} />
            <Route path="close" element={<ValidationPopup key={k++} />} />
            <Route path="map" element={<MapView key={k++} />} />
            <Route path="close/:statusId" element={<ValidationPopup key={k++} />} />
            <Route path="share" element={<Share key={k++} />} />
            <Route path="print" element={<PrintWindow key={k++} />} />
            <Route path="filter" element={<ActionFilter key={k++} />} />
            <Route path="email" element={<EmailModal key={k++} />} />
            <Route path="parent-child" element={<HierarchyWindow key={k++} />} />
            <Route path="unpin/:pinId" element={<DeleteDockItem key={k++} />} />
            <Route path="notes" element={<AINotes key={k++} />} />
            <Route path="ownership" element={<AssignedModal key={k++} />} />
            <Route path="allocation" element={<AllocationModal key={k++} />} />
            <Route path="related" element={<RelatedTicketsModal key={k++} />} />
            <Route path="move" element={<MoveTicketsModal key={k++} />} />
            <Route path="Kbase" element={<KBModal key={k++} />} />
            <Route path="assets" element={<AssetModal key={k++} />}>
                <Route path="add" element={<AddAssetModal key={k++} />} />
                {/* <Route index={true} element={<AssetModal key={k++} />} /> */}
            </Route>
            <Route path="add-asset" element={<AddAssetModal key={k++} />} />
        </Routes>)

}

export interface TicketLocationState {
    background?: Location;
}

export default TicketRoutes;
